import styled from "styled-components";
import Globais from "../../css/Globais";
import CustomMenu from "../Menu";
import { useMediaQuery } from "react-responsive";
import {
  HeartOutlined,
  HomeOutlined,
  LoadingOutlined,
  LogoutOutlined,
  MessageOutlined,
  PhoneOutlined,
  SettingFilled,
  SmileOutlined,
  SyncOutlined,
  TeamOutlined,
  UserOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';


import { TabBar } from "antd-mobile";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { logout } from "../Globais";

const Container = styled.div`
  font-size: 0.5rem;
  font-family: arial, helvetica, sans-serif;
  color: #fff;
  width: 90%;
  height: calc(
    100vh - 8rem
  ); /* Ajustando para que o topo tenha um espaço de 8rem */
  top: 8rem;
  border-radius: 0.5rem;
  position: absolute;
  background-color: ${Globais.CorVerde};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  z-index: 1000;
  font-weight: bold;
  overflow-y: auto; /* Adicionando a rolagem vertical */
  padding-right: 10px; /* Para evitar sobreposição da rolagem na borda */

  a:link {
    text-decoration: none;
    color: inherit;
  }

  a:visited {
    color: #fff;
  }

  @media (min-width: 400px) and (max-width: 499px) and (min-height: 200px) {
    max-width: 25rem;
    top: 8rem;
  }

  @media (min-width: 400px) and (max-width: 499px) and (min-height: 800px) {
    max-width: 30rem;
    top: 8rem;
  }

  @media (min-width: 500px) and (max-width: 699px) and (min-height: 200px) {
    max-width: 25rem;
    top: 8rem;
  }

  @media (min-width: 500px) and (max-width: 699px) and (min-height: 800px) {
    max-width: 25rem;
    top: 8rem;
  }

  @media (min-width: 700px) and (max-width: 899px) and (min-height: 200px) {
    max-width: 25rem;
    top: 8rem;
  }

  @media (min-width: 700px) and (max-width: 899px) and (min-height: 800px) {
    max-width: 25rem;
    top: 8rem;
  }

  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 200px) {
    max-width: 25rem;
    top: 8rem;
  }

  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 800px) {
    max-width: 30rem;
    top: 8rem;
  }

  @media (min-width: 1100px) and (min-height: 200px) {
    max-width: 20rem;
    top: 6rem;
  }

  @media (min-width: 1100px) and (min-height: 800px) {
    max-width: 20rem;
    top: 6rem;
  }
`;

interface Inda {
  props: string;
}

export default function ToolBarLogin({ props }: Inda) {
  // const nda = +props;
  //  const isMobile = useMediaQuery({ maxWidth: 768 });



  // interface ToolBarLoginProps {
  //   props: string;
  // }

  // interface CustomMenuProps {
  //   userType: "logged" | "admin" | "operator" | "guest";
  // }

  // const ToolBarLogin: React.FC<ToolBarLoginProps> = ({ props }) => {
    const nda = +props;
    const isMobile = useMediaQuery({ maxWidth: 768 });
      const [activeKey, setActiveKey] = useState("home");
      const navigate = useNavigate();
      const location = useLocation();

    //  const tabs = [
    //     {
    //       key: '/home',
    //       title: '首页',
    //       icon: <AppOutline />,
    //     },
    //     {
    //       key: '/todo',
    //       title: '待办',
    //       icon: <UnorderedListOutline />,
    //     },
    //     {
    //       key: '/message',
    //       title: '消息',
    //       icon: <MessageOutline />,
    //     },
    //     {
    //       key: '/me',
    //       title: '我的',
    //       icon: <UserOutline />,
    //     },
    //   ]

    const handleTabChange = (key: string) => {
      // Chamar uma função personalizada com base no item clicado
    if (key === "/") {
       logout();// Aqui você pode colocar qualquer ação desejada
    } 

    // Navegar para a página correspondente
    navigate("" + key);
    }


    return (
      <>
        {isMobile ? (
             <div style={{
                      
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    background: Globais.CorVerde,
                    zIndex: 9999,
                    
              }}>
                   <TabBar 
                      activeKey={location.pathname.replace("/", "")}
                      onChange={handleTabChange } 
                      safeArea
                      style={{
                       
                          color: "#fff",
                      }}
              >
                {nda === 0 || nda === 3 ?(
                  <>
                  <TabBar.Item key="/dadosPessoais" style={{color: "#fff"}} icon={<UserOutlined />} title="Perfil" />
                  <TabBar.Item key="/cadastroCotas" style={{color: "#fff"}}icon={<HomeOutlined />} title="Propriedades" />
                  <TabBar.Item key="/interesses" style={{color: "#fff"}} icon={<HeartOutlined /> } title="Interesses" />
                 
                  <TabBar.Item key="/contato" style={{color: "#fff"}} icon={<MessageOutlined /> } title="Contato" />
                  <TabBar.Item key="/" style={{color: "#fff"}} icon={<LogoutOutlined /> } title="Sair" />
                  </>
                ):(
                  <>
                   <TabBar.Item key="/login" style={{color: "#fff"}} icon={<LogoutOutlined />} title="Login" />
                  <TabBar.Item key="/cadastroPessoais" style={{color: "#fff"}}icon={<UserOutlined />} title="Cadastre-se" />
                  <TabBar.Item key="/quemsomos" style={{color: "#fff"}} icon={<TeamOutlined /> } title="Quem somos" />
                 
                  <TabBar.Item key="/contato" style={{color: "#fff"}} icon={<MessageOutlined /> } title="Contato" />
                  
                  </>
                )}
                  
              </TabBar>
                 </div>
        ) : (
          <></>
          // <Container>
          //   {nda === 0 || nda === 3 ? (
          //     <>
          //       {/* <MenuItem linkProps={menu[1].itens} /> */}
          //       <CustomMenu userType={"logged"} />
          //     </>
          //   ) : nda === 1 ? (
          //     <>
          //       {/* <MenuItem linkProps={menu[2].itens} /> */}
          //       <CustomMenu userType={"admin"} />
          //     </>
          //   ) : nda === 2 ? (
          //     <>
          //       {/* <MenuItem linkProps={menu[2].itens} /> */}
          //       <CustomMenu userType={"operator"} />
          //     </>
          //   ) : (
          //     <>
          //       {/* <MenuItem linkProps={menu[0].itens} /> */}
          //       <CustomMenu userType={"guest"} />
          //     </>
          //   )}
          // </Container>
        )}
      </>
    );
  // };
}
